import { CancelButtonStyled } from '@/components/toolbars/DefaultToolbar/styled';
import { ORDER_ID_HELPER } from './constants';
import {
  Container,
  FieldLabel,
  FieldWrapper,
  HelperText,
  OrderIdField,
  OrderIdRow,
  TextFieldStyled,
  Toolbar,
  UpdateOrderButton,
} from './styled';
import UpdateOrderIdDialog from './UpdateOrderIdDialog';
import { ConnectReportProps } from '../types';
import useController from './useController';
import { DefaultToolbarStyled } from '@/styles/overrides';

const FormContent = (props: ConnectReportProps) => {
  const { connectOrderReport, handleCloseModal, handleOpenModal, handleUpdateOrderId, showUpdateModal } =
    useController(props);

  return (
    <>
      <Container>
        <FieldWrapper>
          <FieldLabel>Report ID</FieldLabel>
          <TextFieldStyled disabled size="small" value={connectOrderReport?.id ?? ''} />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Status</FieldLabel>
          <TextFieldStyled disabled size="small" value={connectOrderReport?.status ?? ''} />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Connect Order ID</FieldLabel>
          <OrderIdRow>
            <OrderIdField>
              <TextFieldStyled disabled size="small" value={connectOrderReport?.connect_order_id ?? ''} />
              <HelperText>{ORDER_ID_HELPER}</HelperText>
            </OrderIdField>
            <UpdateOrderButton variant="outlined" onClick={handleOpenModal}>
              Update Order ID
            </UpdateOrderButton>
          </OrderIdRow>
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Reference ID</FieldLabel>
          <TextFieldStyled disabled size="small" value={connectOrderReport?.reference_id ?? ''} />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Order Request</FieldLabel>
          <TextFieldStyled
            disabled
            multiline
            minRows={3}
            maxRows={15}
            size="small"
            value={JSON.stringify(connectOrderReport?.order_request ?? {}, null, 2)}
          />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Error description</FieldLabel>
          <TextFieldStyled
            disabled
            multiline
            minRows={3}
            size="small"
            value={connectOrderReport?.error_description ?? ''}
          />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Retries</FieldLabel>
          <TextFieldStyled disabled size="small" value={connectOrderReport?.retries ?? ''} />
        </FieldWrapper>
      </Container>

      <DefaultToolbarStyled onClose={props.onClose} renderSaveButton={false} />

      <UpdateOrderIdDialog
        currentConnectOrderId={connectOrderReport?.connect_order_id}
        open={showUpdateModal}
        onClose={handleCloseModal}
        onSubmit={handleUpdateOrderId}
      />
    </>
  );
};

export default FormContent;
